import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Toyotaetiononrentinmumbai() {



const cardData = {
  keyword: " Toyota Etios on Rent in Mumbai",

headingDescription:
  "Omshree Cab offers affordable and comfortable Toyota Etios on rent in Mumbai for travelers who want a smooth, reliable, and fuel‑efficient ride for city travel, airport transfers, family outings, corporate travel, or outstation trips. The Toyota Etios is a popular sedan known for its spacious interiors, comfortable seating, and excellent mileage, making it ideal for solo travelers, couples, and small families. Our flexible rental options include one‑way bookings, round trips, hourly packages, and full‑day rentals with transparent pricing and no hidden charges. Each Etios in our fleet is air‑conditioned, well‑maintained, and driven by an experienced chauffeur familiar with Mumbai’s roads and traffic conditions. With easy online booking, punctual pickups from anywhere in Mumbai (including airports, railway stations, hotels, and residences), and 24/7 customer support, renting a Toyota Etios becomes a seamless and stress‑free experience.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located along the Arabian Sea in South Mumbai. Built during the British era, this historic monument attracts tourists for photography, sightseeing, and ferry rides to Elephanta Island. The lively Colaba area around the Gateway features heritage buildings, street markets, and cafes. Renting a Toyota Etios makes it comfortable for travelers to reach this famous destination and explore nearby attractions without the stress of city traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road stretching along the Arabian Sea, popularly called the Queen’s Necklace because of its glittering lights at night. Visitors enjoy sunset views, evening walks, and the refreshing sea breeze along this iconic boulevard. The route connects several attractions in South Mumbai, making it ideal for sightseeing. A Toyota Etios rental provides a smooth, comfortable ride while exploring Marine Drive and surrounding areas."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most loved beaches, known for its sandy shores, lively atmosphere, and famous street food like pav bhaji, bhel puri, and pani puri. Tourists and locals visit throughout the year to enjoy the sea breeze and sunset views. Renting a Toyota Etios ensures a comfortable trip to Juhu Beach and nearby attractions, perfect for family outings or casual city drives."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple in Mumbai dedicated to Lord Ganesha. Devotees from across India visit to seek blessings and experience the temple’s peaceful atmosphere. The temple attracts large crowds during festivals like Ganesh Chaturthi. Renting a Toyota Etios provides a reliable and comfortable way to reach this popular spiritual site while avoiding public transport or parking issues."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is a modern cable‑stayed bridge connecting Bandra and Worli across the Arabian Sea. The bridge offers breathtaking views of the sea and city skyline, especially at sunset or night when the lights illuminate the structure. Driving on the Sea Link is a memorable experience for visitors. Renting a Toyota Etios ensures a smooth and comfortable journey while exploring this scenic route."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous Islamic shrine located on a small island off the coast of Mumbai, connected to the mainland by a narrow walkway visible during low tide. The white marble structure and serene surroundings attract visitors from various communities. Renting a Toyota Etios offers a comfortable and convenient ride to this spiritual destination without the hassle of traffic or parking."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves situated on Elephanta Island and are known for their impressive stone carvings dedicated to Lord Shiva. Recognized as a UNESCO World Heritage Site, the caves attract tourists interested in history, culture, and architecture. Visitors usually take a ferry from the Gateway of India to reach the island. Renting a Toyota Etios allows seamless transportation to the ferry terminal, making it a comfortable start to the cultural excursion."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve within Mumbai offering trekking, nature walks, wildlife spotting, and the historic Kanheri Caves. Nature lovers and families visit this green sanctuary to enjoy outdoor activities and scenic trails. Renting a Toyota Etios provides a comfortable ride for a full‑day trip to the park and allows sufficient time to explore the park’s attractions."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a busy shopping street in South Mumbai known for its vibrant markets, boutiques, and local eateries. Visitors enjoy browsing for clothing, jewelry, handicrafts, accessories, and souvenirs. Renting a Toyota Etios ensures a smooth and comfortable journey to this bustling market area and back, making it ideal for shopping excursions and sightseeing."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are landscaped terraced gardens located on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here for peaceful walks, photography, and relaxation amidst greenery. Renting a Toyota Etios provides convenient and comfortable access, making it an excellent choice for including this scenic location in your Mumbai itinerary."
  }
],



services: [
{
name: "Toyota Etios on Rent Mumbai",
description: "Toyota Etios on rent in Mumbai offers comfortable and economical sedan transportation for passengers traveling within the city or to nearby destinations. The Toyota Etios is known for its spacious seating, reliable performance, and excellent fuel efficiency, making it ideal for taxi services and long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, family trips, and city tours. Air-conditioned interiors ensure comfortable journeys. Flexible booking options allow easy ride reservations anytime."
},
{
name: "Etios Cab Service Mumbai",
description: "Etios cab service in Mumbai provides reliable and affordable sedan transportation for passengers seeking comfortable city travel. The Toyota Etios sedan offers smooth ride quality, spacious seating, and excellent mileage suitable for daily commuting and long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, business trips, and family travel. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow convenient cab reservations."
},
{
name: "Etios Taxi Mumbai",
description: "Etios taxi in Mumbai offers comfortable and budget-friendly sedan travel for passengers moving across the city or nearby destinations. The vehicle provides spacious seating and smooth driving performance suitable for city roads and highways. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, tourism visits, and daily commuting. Air-conditioned interiors ensure comfortable journeys. Easy taxi booking options allow quick reservations."
},
{
name: "Etios Rental Mumbai",
description: "Etios rental in Mumbai provides reliable and economical transportation for passengers seeking comfortable sedan travel. The Toyota Etios offers spacious seating and smooth ride quality suitable for both city travel and long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, and transport hubs. Ideal for business travel, family trips, and sightseeing tours. Comfortable interiors ensure relaxed journeys for passengers. Flexible rental options allow convenient ride scheduling."
},
{
name: "Etios Airport Cab Mumbai",
description: "Etios airport cab in Mumbai provides reliable airport transportation with comfortable seating and luggage capacity. The vehicle ensures smooth travel between airport terminals and city destinations. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for business travelers, tourists, and family airport transfers. Air-conditioned interiors ensure comfortable journeys with luggage. Flexible booking options allow advance reservations."
},
{
name: "Etios Outstation Cab Mumbai",
description: "Etios outstation cab in Mumbai offers comfortable long-distance travel for passengers planning trips outside the city. The Toyota Etios provides smooth highway performance and excellent mileage suitable for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and railway stations. Ideal for weekend trips, pilgrimage tours, and family vacations. Spacious interiors ensure comfortable travel experiences. Flexible one-way and round-trip booking options allow easy travel planning."
},
{
name: "Etios One Way Cab Mumbai",
description: "Etios one way cab in Mumbai offers economical intercity transportation for passengers traveling without return charges. The vehicle provides comfortable seating and smooth highway travel for long routes. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for airport transfers, business trips, and tourism visits. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride reservations."
},
{
name: "Etios Round Trip Taxi Mumbai",
description: "Etios round trip taxi in Mumbai provides convenient transportation for passengers planning return journeys to nearby destinations. The Toyota Etios offers comfortable seating and reliable highway performance for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for family tours, corporate trips, and weekend travel. Comfortable interiors ensure relaxed journeys throughout the trip. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Cheap Etios Rental Mumbai",
description: "Cheap Etios rental in Mumbai offers affordable sedan transportation for passengers looking for budget-friendly travel options. The Toyota Etios provides comfortable seating and smooth rides suitable for city travel and short-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and marketplaces. Ideal for students, daily commuters, and budget travelers. Air-conditioned interiors ensure comfortable journeys. Flexible booking options allow convenient ride scheduling anytime."
},
{
name: "Etios Cab Booking Mumbai",
description: "Etios cab booking in Mumbai allows passengers to easily reserve comfortable sedan transportation for city and outstation travel. Online and phone booking options provide instant ride confirmation and convenient scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, family trips, and airport transfers. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow easy reservations anytime."
},
{
name: "Etios Taxi Booking Mumbai",
description: "Etios taxi booking in Mumbai provides convenient ride reservations for passengers looking for economical sedan transportation. The vehicle offers comfortable seating and smooth travel suitable for city rides and long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, tourism visits, and family travel. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow quick taxi reservations."
},
{
name: "Etios Per Km Rate Mumbai",
description: "Etios per km rate in Mumbai provides transparent pricing for passengers traveling in comfortable Toyota Etios sedan vehicles. The car offers smooth driving performance and economical fuel consumption for city and highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for outstation trips, corporate travel, and family journeys. Comfortable interiors ensure relaxed travel experiences. Clear pricing structure ensures affordable and transparent fares."
},
{
name: "Etios Family Cab Mumbai",
description: "Etios family cab in Mumbai provides comfortable sedan transportation ideal for families traveling together. The Toyota Etios offers spacious seating and smooth ride quality suitable for city rides and weekend trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for family outings, temple visits, and vacations. Comfortable interiors ensure relaxed journeys during travel. Flexible booking options allow easy ride reservations."
},
{
name: "Etios Corporate Cab Mumbai",
description: "Etios corporate cab in Mumbai provides reliable transportation for business executives and corporate employees. The vehicle offers comfortable seating and professional travel suitable for office transfers and meetings. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and business districts. Ideal for corporate meetings, airport transfers, and executive travel. Comfortable interiors ensure relaxed journeys for professionals. Flexible booking options allow scheduled corporate rides."
},
{
name: "Etios Rental Near Me Mumbai",
description: "Etios rental near me in Mumbai helps passengers quickly find nearby sedan rental services for comfortable travel. The Toyota Etios offers spacious seating and smooth ride quality suitable for city and outstation trips. Professional drivers ensure punctual pickup and safe driving services across nearby areas in Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family travel, corporate trips, and airport transfers. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride confirmation."
}
],

tableData: [
["Toyota Etios on Rent Mumbai","Etios Cab Service Mumbai"],
["Etios Taxi Mumbai","Etios Rental Mumbai"],
["Etios Airport Cab Mumbai","Etios Outstation Cab Mumbai"],
["Etios One Way Cab Mumbai","Etios Round Trip Taxi Mumbai"],
["Cheap Etios Rental Mumbai","Etios Cab Booking Mumbai"],
["Etios Taxi Booking Mumbai","Etios Per Km Rate Mumbai"],
["Etios Family Cab Mumbai","Etios Corporate Cab Mumbai"],
["Etios Rental Near Me Mumbai","Toyota Etios Hire Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Toyota Etios Sedan",
    WhyChoosedescription: "Toyota Etios is a reliable and comfortable sedan widely used for taxi services in Mumbai. It offers spacious seating for up to five passengers, smooth suspension, and a stable ride, making it perfect for local and outstation travel." 
  },
  {
    WhyChooseheading: "Affordable Etios Cab Rental",
    WhyChoosedescription: "Omshree Cabs provides budget-friendly Toyota Etios rentals in Mumbai with transparent pricing. Customers receive clear details about per-kilometer fares, toll charges, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Toyota Etios Cab Availability",
    WhyChoosedescription: "Our Toyota Etios cab service in Mumbai operates 24 hours a day. Whether you need an early morning airport drop, late-night pickup, or daytime travel, our Etios taxis are always available."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Toyota Etios vehicles in our fleet are regularly serviced, cleaned, and sanitized to ensure passengers enjoy a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Ideal for Local & Outstation Trips",
    WhyChoosedescription: "Toyota Etios is ideal for city travel in Mumbai as well as outstation trips to destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and Mahabaleshwar due to its smooth ride and fuel efficiency."
  },
  {
    WhyChooseheading: "Professional Chauffeur Drivers",
    WhyChoosedescription: "Our trained drivers are experienced in navigating Mumbai roads and highways, ensuring passengers enjoy a smooth, safe, and punctual travel experience."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so passengers can begin their journey without hassle."
  },
  {
    WhyChooseheading: "Trusted Sedan Taxi Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Toyota Etios rentals in Mumbai because of our punctual drivers, comfortable vehicles, and reliable customer service."
  }
]
};

const faqData = [
  { question: "Do you provide Toyota Etios on rent in Mumbai?", answer: "Yes, Omshree Cabs provides Toyota Etios car rental services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Toyota Etios?", answer: "Toyota Etios is a 5-seater sedan that comfortably accommodates four passengers plus the driver." },
  { question: "Is Toyota Etios suitable for airport transfers?", answer: "Yes, Toyota Etios is commonly used for Mumbai Airport pickup and drop services because of its comfortable seating and luggage space." },
  { question: "Can I book Toyota Etios for outstation travel?", answer: "Yes, we provide Toyota Etios rentals from Mumbai to destinations like Pune, Nashik, Lonavala, Shirdi, and Surat." },
  { question: "Are Toyota Etios vehicles air-conditioned?", answer: "Yes, all Toyota Etios vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Do you provide drivers with the vehicle?", answer: "Yes, all Toyota Etios rentals include professional drivers experienced in city and highway travel." },
  { question: "Is Toyota Etios good for long-distance travel?", answer: "Yes, the Etios sedan is known for reliability, comfort, and fuel efficiency, making it suitable for long-distance travel." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel seasons." },
  { question: "Can I book Etios for full-day travel in Mumbai?", answer: "Yes, we offer full-day and hourly rental packages for Toyota Etios travel within Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Shah",
    feedback:
      "We booked a Toyota Etios from Omshree Cabs for our Mumbai airport transfer. The car was clean and the driver arrived on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "Very reliable Toyota Etios cab service in Mumbai. Affordable pricing and comfortable ride made our trip smooth.",
    rating: 5
  }
];

















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Toyota Etios on Rent in Mumbai",
  "description": "Omshree Cab offers Toyota Etios on rent in Mumbai for local travel, airport transfers, outstation trips, one-way journeys, and round trips. Ideal for families, corporate travel, and budget-friendly trips, our well-maintained Etios cabs provide comfort, safety, and transparent per km rates for a hassle-free experience across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1200"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Toyota Etios on Rent in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Toyota Etios on rent in Mumbai for local travel, airport, outstation, one-way, and round trips. Family and corporate cab with budget-friendly rates, transparent per km charges, and well-maintained vehicles." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Toyotaetiononrentinmumbai;